function FeaturesBar() {
  return (
    <div className="bg-cream dark:bg-background-dark py-8 border-b border-gray-100 dark:border-gray-800">
      <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
        
        {/* Feature 1 - Organic */}
        <div className="flex items-center gap-4 justify-center md:justify-start">
          <span className="material-symbols-outlined text-primary text-4xl">energy_savings_leaf</span>
          <div>
            <h4 className="font-bold text-earth dark:text-white">100% Organic</h4>
            <p className="text-xs text-gray-500 uppercase tracking-widest font-semibold">Natural Feed</p>
          </div>
        </div>

        {/* Feature 2 - Farm Grown */}
        <div className="flex items-center gap-4 justify-center">
          <span className="material-symbols-outlined text-primary text-4xl">potted_plant</span>
          <div>
            <h4 className="font-bold text-earth dark:text-white">Farm Grown</h4>
            <p className="text-xs text-gray-500 uppercase tracking-widest font-semibold">Eco-Friendly</p>
          </div>
        </div>

        {/* Feature 3 - Fresh Delivery */}
        <div className="flex items-center gap-4 justify-center md:justify-end">
          <span className="material-symbols-outlined text-primary text-4xl">local_shipping</span>
          <div>
            <h4 className="font-bold text-earth dark:text-white">Fresh Delivery</h4>
            <p className="text-xs text-gray-500 uppercase tracking-widest font-semibold">Farm to Door</p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default FeaturesBar;